import { render, staticRenderFns } from "./representative-type-selector.vue?vue&type=template&id=420a3da0&scoped=true&"
import script from "./representative-type-selector.vue?vue&type=script&lang=js&"
export * from "./representative-type-selector.vue?vue&type=script&lang=js&"
import style0 from "./representative-type-selector.vue?vue&type=style&index=0&id=420a3da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420a3da0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
